import history from '../../hashHistory';
import { QueryParams } from './queryParams.types';

export const getQueryParam = <T extends keyof QueryParams>(param: T) => {
  const urlParams = new URLSearchParams(history.location.search);

  return urlParams.get(param) as QueryParams[T];
};
